export default "__VITE_ASSET__B6yu16cq__"